<div class="qr-scanner-video-container">
  <video #videoElement class="qr-scanner-video"></video>
</div>
